<template>
  <div class="molecule-alert-notification_container">
    <div
      v-if="notification"
      :class="[
        isAddNotification ? 'padding-card--except-bottom' : 'padding-card--all',
      ]"
    >
      <div class="molecule-alert-notification_header">
        <label class="header__text--title">Notification</label> <br />
        <label v-if="canUpdate" class="header__text--sub-title"
          >* Please add at least 1 notification</label
        >
      </div>
      <div class="molecule-alert-notification_content">
        <div class="content__email">
          <label class="content__text--title">EMAIL</label>
          <div class="content__body">
            <label
              v-if="notification.email.length === 0"
              class="content__text--empty"
              >{{ canUpdate ? 'Please add email' : '-' }}</label
            >
            <div v-if="notification">
              <div v-for="(email, index) in notification.email" :key="index">
                <div class="body__list">
                  <label class="body__text--title">{{
                    email.alertEmailAddress
                  }}</label>
                  <feather-icon
                    v-if="canUpdate"
                    class="icon-size-20px icon-danger"
                    icon="TrashIcon"
                    @click="
                      clickDelete('Email', email.alertEmailAddress, index)
                    "
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content__sms">
          <label class="content__text--title">SMS</label>
          <div class="content__body">
            <label
              v-if="notification.sms.length === 0"
              class="content__text--empty"
              >{{ canUpdate ? 'Please add SMS' : '-' }}</label
            >
            <div v-else>
              <div v-for="(sms, index) in notification.sms" :key="index">
                <div class="body__list">
                  <div class="list__container">
                    <label class="body__text--title">{{
                      sms.alertSmsName
                    }}</label>
                    <label class="body__text--body">{{
                      sms.alertSmsNumber
                    }}</label>
                  </div>
                  <feather-icon
                    v-if="canUpdate"
                    class="icon-size-20px icon-danger"
                    icon="TrashIcon"
                    @click="clickDelete('SMS', sms.alertSmsName, index)"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content__line">
          <label class="content__text--title">LINE NOTIFY</label>
          <div class="content__body">
            <label
              v-if="notification.line.length === 0"
              class="content__text--empty"
              >{{ canUpdate ? 'Please add LINE Notify' : '-' }}</label
            >
            <div v-else>
              <div v-for="(line, index) in notification.line" :key="index">
                <div class="body__list">
                  <div class="list__container">
                    <label class="body__text--title">{{
                      line.alertLineTokenName
                    }}</label>
                    <div class="body__text--body">
                      Line notify token {{ line.alertLineToken }}
                    </div>
                  </div>
                  <feather-icon
                    v-if="canUpdate"
                    class="icon-size-20px icon-danger"
                    icon="TrashIcon"
                    @click="
                      clickDelete('Line Notify', line.alertLineTokenName, index)
                    "
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isEmptyNotificationData"
        class="error-message__container-small-screen"
      >
        <feather-icon icon="AlertCircleIcon" stroke="#ea5455"></feather-icon
        ><label class="error-message-style"
          >Please select at least 1 notification</label
        >
      </div>
      <div
        v-if="!isAddNotification"
        class="molecule-alert-notification_footer"
        :class="[isEmptyNotificationData ? 'flex-space-between' : 'flex-end']"
      >
        <div
          v-if="isEmptyNotificationData"
          class="error-message__container-large-screen"
        >
          <feather-icon icon="AlertCircleIcon" stroke="#ea5455"></feather-icon
          ><label class="error-message-style"
            >Please select at least 1 notification</label
          >
        </div>
        <div v-if="canUpdate" class="add-notification-button__container">
          <atom-button
            buttonId="add-notification"
            buttonStyle="border"
            @click="clickAddNotification"
          >
            <template>Add Notification</template>
          </atom-button>
        </div>
      </div>
    </div>
    <div
      v-if="isAddNotification"
      class="molecule-alert-notification_add-notification"
    >
      <div class="padding-card--except-top">
        <div class="add-notification__header">
          <label class="header__text">ADD NOTIFICATION</label>
          <feather-icon
            class="icon-size-20px icon-gray"
            icon="XIcon"
            @click="isAddNotification = false"
          ></feather-icon>
        </div>
        <div
          :class="[
            currentNotificationType === 'Email'
              ? 'add-notification__body-email'
              : 'add-notification__body',
          ]"
        >
          <div class="body__container">
            <div class="body__select">
              <label class="select__text">Notification</label>
              <atom-select
                :option="NotificationTypeList"
                :isClearable="false"
                v-model="currentNotificationType"
              ></atom-select>
            </div>
            <div class="body__input">
              <div
                v-if="currentNotificationType === 'Email'"
                class="input__container"
              >
                <div class="input__width-email">
                  <atom-input
                    title="Email"
                    :isAsterisk="true"
                    :isError="isErrorEmail"
                    :errorMessage="
                      addEmail === ''
                        ? 'Please enter email'
                        : 'Please enter a valid email'
                    "
                    placeholder="Email"
                    v-model="addEmail"
                  ></atom-input>
                </div>
              </div>
              <div
                v-if="currentNotificationType === 'SMS'"
                class="input__container"
              >
                <div class="input__width-fix">
                  <atom-input
                    title="Name"
                    :isAsterisk="true"
                    :isError="isErrorSMSName"
                    errorMessage="Please enter name"
                    placeholder="Name"
                    v-model="addSMSName"
                  ></atom-input>
                </div>
                <div class="input__width input__margin">
                  <atom-input
                    title="Phone number"
                    :isAsterisk="true"
                    :isError="isErrorSMSPhoneNumber"
                    :errorMessage="
                      addSMSPhoneNumber === ''
                        ? 'Please enter phone number'
                        : 'Please enter a valid phone number'
                    "
                    placeholder="Phone number"
                    v-model="addSMSPhoneNumber"
                  ></atom-input>
                </div>
              </div>
              <div
                v-if="currentNotificationType === 'Line Notification'"
                class="input__container"
              >
                <div class="input__width-fix">
                  <atom-input
                    title="Name"
                    :isAsterisk="true"
                    :isError="isErrorLineName"
                    errorMessage="Please enter name"
                    placeholder="Name"
                    v-model="addLineName"
                  ></atom-input>
                </div>
                <div class="input__width-lg input__margin">
                  <atom-input
                    title="Line Notify Token"
                    :isAsterisk="true"
                    :isError="isErrorLineToken"
                    errorMessage="Please enter line notify token"
                    placeholder="Line Notify Token"
                    v-model="addLineToken"
                  >
                  </atom-input>
                </div>
              </div>
            </div>
          </div>
          <div
            class="body__button"
            :class="{
              'body__button--error':
                isErrorEmail ||
                isErrorSMSName ||
                isErrorSMSPhoneNumber ||
                isErrorLineName ||
                isErrorLineToken,
            }"
          >
            <atom-button
              buttonId="add-notification"
              :isDisable="isDisableButtonAdd"
              @click="clickAdd"
            >
              <feather-icon icon="PlusIcon" /> <span>Add</span>
            </atom-button>
          </div>
        </div>
      </div>
    </div>
    <molecule-modal-dialog
      modalId="modal-confirm-delete-notification"
      :isTextCenter="true"
      icon="AlertCircleIcon"
      :textTitle="`Do you want to delete ${currentType}\n“${currentName}”?`"
      buttonTextLeft="Delete"
      buttonTextRight="Cancel"
      buttonColorLeft="danger"
      @clickButtonLeft="clickConfirmDelete"
    >
    </molecule-modal-dialog>
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
export default {
  name: "MoleculeAlertNotification",
  components: { AtomButton, AtomSelect, AtomInput, MoleculeModalDialog },
  props: {
    notificationData: {
      type: Object,
      required: true,
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["alertNotification"],
  data() {
    return {
      modalId: "",
      notification: null,
      isAddNotification: false,
      NotificationTypeList: ["Email", "SMS", "Line Notification"],
      currentNotificationType: "Email",
      // v-model
      addEmail: "",
      addSMSName: "",
      addSMSPhoneNumber: "",
      addLineName: "",
      addLineToken: "",
      // is validate
      isValidateEmail: false,
      isValidateSMS: false,
      isValidateLine: false,
      // current notification
      currentIndex: 0,
      currentType: "Email",
      currentName: "",
    }
  },
  computed: {
    isEmptyNotificationData() {
      if (this.isValidateTrigger) {
        return (
          this.notificationData.email.length === 0 &&
          this.notificationData.sms.length === 0 &&
          this.notificationData.line.length === 0
        )
      }
      return false
    },
    isErrorEmail() {
      return this.currentNotificationType === "Email"
        ? this.isValidateEmail && !this.validateEmail(this.addEmail)
        : false
    },
    isErrorSMSName() {
      return this.currentNotificationType === "SMS"
        ? this.isValidateSMS && !this.validateEmpty(this.addSMSName)
        : false
    },
    isErrorSMSPhoneNumber() {
      return this.currentNotificationType === "SMS"
        ? this.isValidateSMS &&
            !this.validatePhoneNumber(this.addSMSPhoneNumber)
        : false
    },
    isErrorLineName() {
      return this.currentNotificationType === "Line Notification"
        ? this.isValidateLine && !this.validateEmpty(this.addLineName)
        : false
    },
    isErrorLineToken() {
      return this.currentNotificationType === "Line Notification"
        ? this.isValidateLine && !this.validateEmpty(this.addLineToken)
        : false
    },
    // disable button
    isDisableButtonAdd() {
      if (this.isValidateEmail && this.currentNotificationType === "Email") {
        return this.isErrorEmail
      } else if (this.isValidateSMS && this.currentNotificationType === "SMS") {
        return this.isErrorSMSName && this.isErrorSMSPhoneNumber
      } else if (
        this.isValidateLine &&
        this.currentNotificationType === "Line Notification"
      ) {
        return this.isErrorLineName && this.isErrorLineToken
      }
    },
  },
  mounted() {
    this.notification = this.notificationData
  },
  watch: {
    notification: {
      deep: true,
      handler() {
        this.$emit("alertNotification", this.notification)
      },
    },
    currentNotificationType() {
      this.clearAllAddNotification()
    },
  },
  methods: {
    clickAddNotification() {
      this.clearAllAddNotification()
      this.isAddNotification = true
    },
    clickAdd() {
      if (this.currentNotificationType === "Email") {
        this.isValidateEmail = true
        if (!this.isErrorEmail) {
          this.notification.email.push({ alertEmailAddress: this.addEmail })
          this.isValidateEmail = false
          this.addEmail = ""
          this.isAddNotification = false
        }
      } else if (this.currentNotificationType === "SMS") {
        this.isValidateSMS = true
        if (!this.isErrorSMSName && !this.isErrorSMSPhoneNumber) {
          this.notification.sms.push({
            alertSmsName: this.addSMSName,
            alertSmsNumber: this.addSMSPhoneNumber,
          })
          this.isValidateSMS = false
          this.addSMSName = ""
          this.addSMSPhoneNumber = ""
          this.isAddNotification = false
        }
      } else {
        this.isValidateLine = true
        if (!this.isErrorLineName && !this.isErrorLineToken) {
          this.notification.line.push({
            alertLineTokenName: this.addLineName,
            alertLineToken: this.addLineToken,
          })
          this.isValidateLine = false
          this.addLineName = ""
          this.addLineToken = ""
          this.isAddNotification = false
        }
      }
    },

    // delete notifications
    clickDelete(type, name, index) {
      this.currentIndex = index
      this.currentType = type
      this.currentName = name

      this.modalId = "modal-confirm-delete-notification"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmDelete() {
      this.closeModal()
      if (this.currentType === "Email") {
        this.notification.email.splice(this.currentIndex, 1)
      } else if (this.currentType === "SMS") {
        this.notification.sms.splice(this.currentIndex, 1)
      } else {
        this.notification.line.splice(this.currentIndex, 1)
      }
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    // validate empty
    validateEmpty(word) {
      if (word === "") return false
      else return true
    },
    // regex
    validatePhoneNumber(phoneNumber) {
      const phone = /^0[0-9]{9,10}$/
      return phone.test(phoneNumber)
    },
    validateEmail(emailAddress) {
      const email = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      return email.test(emailAddress)
    },

    clearAllAddNotification() {
      this.addEmail = ""
      this.addSMSName = ""
      this.addSMSPhoneNumber = ""
      this.addLineName = ""
      this.addLineToken = ""

      this.isValidateEmail = false
      this.isValidateSMS = false
      this.isValidateLine = false
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-alert-notification_container {
  background: #ffffff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  width: 100%;
}

.padding-card--all {
  padding: 1.5rem;
}
.padding-card--except-bottom {
  padding: 1.5rem 1.5rem 0;
}
.padding-card--except-top {
  padding: 0 1.5rem 1.5rem;
}
// header
.molecule-alert-notification_header {
  margin-bottom: 15px;
}
.header__text--title {
  margin-bottom: 0;
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}
.header__text--sub-title {
  color: #82868b;
  font-size: 12px;
}

// content
.content__email,
.content__sms,
.content__line {
  width: 100%;
}
.content__email,
.content__sms {
  margin-bottom: 32px;
}
.content__body {
  margin-top: 5px;
}
.body__list {
  margin-top: 10px;
  padding: 0 10px 10px;
  border-bottom: 1px solid #ebe9f1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list__container {
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 30px);
}

// style text
.content__text--title {
  color: #b9b9c3;
  font-weight: 500;
  font-size: 12px;
}
.content__text--empty {
  color: rgba(115, 103, 240, 0.6);
  font-weight: 400;
  font-size: 12px;
}
.body__text--title {
  color: #6e6b7b;
  font-weight: 600;
  font-size: 14px;
  word-break: break-all;
}
.body__text--body {
  color: #82868b;
  font-weight: 400;
  font-size: 12px;
  height: 16px;
  margin-bottom: 0.2857rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

// footer
.molecule-alert-notification_footer {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0 10px 0;
}

// add-notificaiton
.molecule-alert-notification_add-notification {
  margin: 40px 0 10px 0;
  width: 100%;
  border-top: 1px solid #ebe9f1;
}
.add-notification__header {
  margin-top: 21px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header__text {
  color: #b9b9c3;
  font-weight: 500;
  font-size: 12px;
}
.add-notification__body,
.add-notification__body-email {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}
.body__container {
  display: block;
}
.body__select {
  width: 100%;
}
.select__text {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
}
.body__input {
  margin-left: 0;
  margin-top: 1rem;
}
.input__container {
  display: block;
}
.input__width,
.input__width-fix,
.input__width-lg,
.input__width-email {
  width: 100%;
  display: flex;
  align-items: flex-start;
}
.input__margin {
  margin: 1rem 0 0 0;
}
.body__button {
  display: flex;
  justify-content: end;
  align-items: flex-end;
  margin-top: 1rem;
}

.body__button--error {
  margin-bottom: 22px;
}
.button__x {
  margin-left: 10px;
}

.error-message-style {
  margin: 0;
  padding-left: 5px;
  font-size: 12px;
  color: #ea5455;
}

.error-message__container-small-screen {
  display: flex;
  align-content: flex-start;
  margin-top: 10px;
}

.error-message__container-large-screen {
  display: none;
}

.add-notification-button__container {
  display: flex;
  align-items: center;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .body__select {
    width: 49%;
  }
  .body__input {
    display: flex;
  }
  .input__container {
    display: flex;
    width: 100%;
  }
  .input__margin {
    margin: 0 0 0 15px;
  }
  .body__button {
    margin-left: 30px;
    margin-top: 23px;
  }
}
// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .body__select {
    width: 281px;
  }
  // content
  .molecule-alert-notification_content {
    display: flex;
    justify-content: space-between;
  }
  .content__email,
  .content__sms,
  .content__line {
    display: flex;
    flex-direction: column;
    width: calc(33% - 32px);
  }
  .content__email,
  .content__sms {
    margin-bottom: 0;
    margin-right: 32px;
  }

  // add-notification
  .add-notification__body-email {
    flex-direction: row;
  }
  .input__width {
    width: calc(100% - 296px);
  }
  .input__width-fix {
    width: 281px;
  }
  .input__width-lg {
    width: calc(100% - 296px);
  }
  .input__width-email {
    width: 450px;
  }

  .error-message__container-large-screen {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .error-message__container-small-screen {
    display: none;
  }

  .molecule-alert-notification_footer {
    margin: 50px 0 10px 0;
  }

  .flex-space-between {
    display: flex;
    justify-content: space-between;
  }

  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  // add-notification
  .add-notification__body {
    margin-top: 15px;
    flex-direction: row;
    align-items: flex-end;
  }
  .input__width {
    width: 281px;
  }
  .input__width-lg {
    width: 384px;
  }
  .input__container {
    width: auto;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}

// Extra X-Large devices (large desktops, 1440px and up)
@media screen and (min-width: 1440px) {
  .body__select {
    width: 250px;
  }
  .body__container {
    display: flex;
  }
  .body__input {
    margin-left: 30px;
    margin-top: 0;
  }
}
</style>
